// /////////////////////////////////////////////////////////////////////////////////////
//                           Copyright (c) 2025
//                                  RXO Inc.
//                          All Rights Reserved Worldwide
// 
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
// /////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import messages from "../helpers/messages";

export const ForbiddenAccess = () => {
  return (
    <div
      data-testid="forbidden-access"
      className="flex justify-center items-center text-center app-level-error"
    >
      <div className="content">
        <p className="univers-65-bold color-grey title">
          {messages.accessDenied.defaultMessage}
        </p>
        <p className="py-8 text-dim-grey message">
          {messages.noPermissionToViewPage.defaultMessage}
        </p>
      </div>
    </div>
  );
};

export default ForbiddenAccess;
